// extracted by mini-css-extract-plugin
module.exports = {"PlanIcon":"PlanIcon_PlanIcon__2x7u2","perGB":"PlanIcon_perGB__3Q3dl","unlimitedPlan":"PlanIcon_unlimitedPlan__60GKc","fixedPlan":"PlanIcon_fixedPlan__3U0gf"};